// extracted by mini-css-extract-plugin
export default {"card":"Card_card__pSup9","link":"Card_link__0uNcT","highlight":"Card_highlight__o0WrU"};